import BlockMap from './block-map';

export default class BlockMapDesktop extends BlockMap {
	constructor(...args) {
		super(...args);
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/block-map/block-map.desktop.js